module.exports = __webpack_public_path__ + "static/hw3-aa554bed0153f9cc9b6265709c4b3b6a.jpg";